module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-64-min.3f4e456f.jpg";